export class TemplateComponents {
    type: string;
    text: string;
    example?: any;
    format?: string
    constructor(
        type: string,
        text: string,
        example?: any,
        format?: string
    ) {
        this.text = text
        this.type = type
        this.example = example
        this.format = format
    }
}